import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMagnifyingGlass = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M25.9073 29.2757C21.6517 31.9953 15.947 31.4991 12.2234 27.7782C7.82102 23.3681 7.93108 16.1559 12.5352 11.8836C16.8091 7.92377 23.6511 8.06158 27.7783 12.1776C31.6395 16.0364 32.0339 22.0543 28.9706 26.3633L34.1073 31.5",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})
});
const ForwardRef = forwardRef(SvgMagnifyingGlass);
export default ForwardRef;
